import { useEffect, useState } from "react";
import { Boxes, Plus, X, Save } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function StandardSkusSettings() {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/settings/standard-skus").then((r) => setItems(r.data.items || [])).catch(() => {}); }, []);

  const addRow = () => setItems((prev) => [...prev, { sku: "", default_qty: 1 }]);
  const update = (i, field, value) => setItems((prev) => prev.map((it, idx) => (idx === i ? { ...it, [field]: value } : it)));
  const remove = (i) => setItems((prev) => prev.filter((_, idx) => idx !== i));
  const save = async () => {
    const clean = items.filter((it) => (it.sku || "").trim()).map((it) => ({ sku: it.sku.trim().toUpperCase(), default_qty: Math.max(1, parseInt(it.default_qty) || 1) }));
    setSaving(true);
    try {
      const { data } = await api.put("/settings/standard-skus", { items: clean });
      setItems(data.items || []);
      toast.success("Materiali standard aggiornati");
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <div className="rounded-xl border border-border bg-card p-6" data-testid="std-skus-settings">
      <div className="mb-1 flex items-center gap-2"><Boxes size={18} className="text-primary" /><h3 className="font-bold text-navy">Materiali standard impianto</h3></div>
      <p className="mb-4 text-sm text-muted-foreground">SKU sempre suggeriti ai tecnici da mobile. Imposta la quantità predefinita proposta. Il codice produttore viene letto dal Magazzino.</p>

      <div className="space-y-2">
        <div className="hidden grid-cols-[1fr_90px_40px] gap-2 px-1 sm:grid">
          <Label className="text-xs">SKU</Label>
          <Label className="text-xs">Qtà default</Label>
          <span />
        </div>
        {items.length ? items.map((it, i) => (
          <div key={i} className="grid grid-cols-1 gap-2 rounded-lg border border-border p-2 sm:grid-cols-[1fr_90px_40px] sm:border-0 sm:p-0" data-testid={`std-row-${i}`}>
            <Input value={it.sku} onChange={(e) => update(i, "sku", e.target.value)} placeholder="SKU" className="font-mono" data-testid={`std-sku-input-${i}`} />
            <Input type="number" min="1" value={it.default_qty ?? 1} onChange={(e) => update(i, "default_qty", e.target.value)} data-testid={`std-qty-input-${i}`} />
            <Button variant="ghost" size="icon" onClick={() => remove(i)} data-testid={`std-remove-${i}`} className="text-destructive"><X size={16} /></Button>
          </div>
        )) : <p className="text-sm text-muted-foreground">Nessuno SKU configurato.</p>}
      </div>

      <div className="mt-4 flex gap-2">
        <Button variant="outline" onClick={addRow} data-testid="std-add-row"><Plus size={16} />Aggiungi SKU</Button>
        <Button onClick={save} disabled={saving} data-testid="std-sku-save"><Save size={16} />Salva</Button>
      </div>
    </div>
  );
}
